import React from "react";
import * as Icons from "lucide-react";
import { WHY_US, STATS } from "../../lib/data";

export default function WhyChooseUs() {
  return (
    <section
      id="why"
      data-testid="why-section"
      className="relative py-24 md:py-32 bg-[#0a0a0a] border-y border-white/5"
    >
      <div className="mx-auto max-w-[1500px] px-6 md:px-12 lg:px-24">
        <div className="grid lg:grid-cols-12 gap-12 mb-16">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3 mb-6">
              <span className="h-px w-10 bg-gold"></span>
              <span className="text-[11px] uppercase tracking-[0.32em] text-white/60">
                Why Acnira
              </span>
            </div>
            <h2 className="font-display text-white text-4xl sm:text-5xl lg:text-6xl leading-[0.95] tracking-tight">
              The studio of choice for businesses with
              <span className="italic gold-text-gradient"> standards</span>.
            </h2>
          </div>
          <div className="lg:col-span-6 lg:col-start-7">
            <p className="text-white/60 leading-relaxed text-lg">
              We don't chase trends. We build digital products with the rigour of a
              luxury house and the discipline of a profitable agency. The result is
              work that lasts a decade and pays for itself in months.
            </p>
          </div>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {WHY_US.map((w, i) => {
            const Icon = Icons[w.icon] || Icons.Star;
            return (
              <div
                key={w.title}
                data-testid={`why-card-${i}`}
                className="group relative p-8 border border-white/8 bg-[#0f0f0f] hover:border-gold/30 transition-all duration-500"
              >
                <div className="text-gold mb-6">
                  <Icon size={28} strokeWidth={1.4} />
                </div>
                <div className="font-display text-white text-2xl mb-3">{w.title}</div>
                <p className="text-white/55 leading-relaxed text-sm">{w.text}</p>
                <div className="absolute top-6 right-6 text-[10px] tracking-[0.3em] text-white/20">
                  0{i + 1}
                </div>
              </div>
            );
          })}
        </div>

        {/* Stats */}
        <div
          data-testid="stats-row"
          className="mt-20 grid grid-cols-2 lg:grid-cols-4 divide-x divide-white/8 border-y border-white/8"
        >
          {STATS.map((s, i) => (
            <div key={i} className="px-6 py-10 text-center">
              <div className="font-display text-4xl md:text-5xl gold-text-gradient">
                {s.value}
              </div>
              <div className="mt-3 text-[11px] uppercase tracking-[0.3em] text-white/50">
                {s.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
